import React from "react"
import { BetInfo } from "@orbitalgaming/games-frontend-library"
import { BET_INFO } from "./interfaces"
import Text from "components/text/index"
import { colors } from "lib/colors"
import getBetInfo from "./helper/betInfo"

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const BetInfoComponent = ({
  data,
  title,
  currency,
  precision,
}: BET_INFO): JSX.Element => {
  const { BET_INFO } = getBetInfo(data, precision, currency)

  return (
    <>
      <Text
        size='18px'
        color={colors.secondary}
        // textTransform='uppercase'
        align='left'
        justify='flex-start'
        marginTop='20px'
        marginBottom='6px'
      >
        <> {title}</>
      </Text>
      <BetInfo content={BET_INFO} size='16px' />
    </>
  )
}
